import { Box, Typography } from "@mui/material";
import React from "react";
import { WalletDetial } from "../../../models/settlement.model";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

interface Props {
  creditAmount: number;
  cashAmount: number;
  totalAmount: number;
  settlemAmount: number;
  walletDetail: WalletDetial[];
}

const SellDetail = ({
  cashAmount,
  creditAmount,
  settlemAmount,
  totalAmount,
  walletDetail,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: "100%",
      }}
    >
      <Box>
        {/* first section */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
            display: "flex",
            padding: "20px",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Box
            sx={{
              borderBottom:
                walletDetail?.length > 0 ? "2px dashed #DAE0E4" : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "20px",
            }}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              مبلغ پرداخت اعتباری:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {creditAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
          {walletDetail?.map((wallet) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "20px",
              }}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                {wallet?.walletName}
              </Typography>
              <Typography sx={{ fontSize: "1rem", color: "#34495E" }}>
                {Math.abs(wallet?.walletAmount)?.toLocaleString("fa")}{" "}
                <span style={{ fontSize: ".9rem" }}>ریال</span>
                {wallet?.walletAmount > 0 ? (
                  <ArrowUpwardOutlinedIcon sx={{ color: "#01AF43" }} />
                ) : (
                  <ArrowDownwardOutlinedIcon sx={{ color: "#E6123D" }} />
                )}
              </Typography>
            </Box>
          ))}
        </Box>
        {/* second sections */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
            }}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              مبلغ پرداخت نقدی:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {cashAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
          {!!cashAmount && (
            <Box sx={{ padding: "10px 20px" }}>
              <Typography
                sx={{
                  color: "#FB8C00",
                  fontSize: ".875rem",
                  fontWeight: "bold",
                }}
              >
                توجه داشته باشید این مبلغ باید توسط فروشنده به صورت نقدی از
                خریدار دریافت شود.
              </Typography>
            </Box>
          )}
        </Box>
        {/* third section */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px",
            backgroundColor: "#F9FAFC",
          }}
        >
          <Typography
            sx={{
              fontSize: ".9rem",
              color: "#9AAFC4",
            }}
          >
            جمع کل فاکتور:
          </Typography>
          <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
            {totalAmount?.toLocaleString("fa")}{" "}
            <span style={{ fontSize: ".9rem" }}>ریال</span>
          </Typography>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            border: "1px solid #DAE0E4",
            backgroundColor: "#FFEED9",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px",
          }}
        >
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#34495E",
              fontWeight: "bold",
            }}
          >
            مبلغ تسویه حساب با پذیرنده:
          </Typography>
          <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
            {settlemAmount?.toLocaleString("fa")}{" "}
            <span style={{ fontSize: ".9rem" }}>ریال</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SellDetail;
